import { combineReducers } from "@reduxjs/toolkit";
import { RootState } from "..";
import wheelTableSlice from './wheelTableStore'
import wheelSlice from './Database/wheelStore'
import wheelProfileSlice from './Profile/wheelProfileStore'
// export selectors
export const selectWheel = (state: RootState) => state.wheel;

export const selectWheelTable = (state: RootState) => state.wheel.tables;

export const selectWheelEntity = (state: RootState) => state.wheel.entity;

export const selectWheelProfile = (state: RootState) => state.wheel.profile;

export const wheelReducer = combineReducers({
  tables: wheelTableSlice,
  entity: wheelSlice,
  profile: wheelProfileSlice,
});
